module.exports = __webpack_public_path__ + "img/app_t4oo.dd444f26.png";